export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('uppercase', {
    updated(el, binding) {
      if (!binding.value) return

      const input = el.querySelector('input')
      if (!input) return

      // Use a microtask to ensure this runs after Vue's DOM updates
      setTimeout(() => {
        const sourceValue = input.value
        const newValue = sourceValue.toUpperCase()

        if (sourceValue !== newValue) {
          // Preserve cursor position
          const cursorStart = input.selectionStart
          const cursorEnd = input.selectionEnd

          // Update the input value
          input.value = newValue

          // Restore cursor position
          input.setSelectionRange(cursorStart, cursorEnd)

          // Trigger the input event for two-way binding
          input.dispatchEvent(new Event('input', { bubbles: true }))
        }
      })
    },
  })
})
